import create from 'zustand';

const useMode = create((set, get) => ({
    // can be
    // + intro
    // + ar
    // + item
    // + error
    mode: 'intro',
    set: (mode) => set({ mode: mode }),
}));

export default useMode;
